<template>
  <div class="fill-box">
    <div class="fill-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fillBox'
}
</script>

<style scoped>
.fill-box {
  flex: 1;
  position: relative;
  width: 100%;
}
.fill-box-content {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
</style>
